import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterDadosContatosState } from '../reducers/obter-dados-contatos.reducer';

export const selectObterDadosContatosState = createFeatureSelector<ObterDadosContatosState>('obterDadosContatos');

export const selectObterDadosContatos = createSelector(
  selectObterDadosContatosState,
  (state: ObterDadosContatosState) => state.response
);

export const selectErrosObterDadosContatos = createSelector(
  selectObterDadosContatosState,
  (state: ObterDadosContatosState) => state.error
);
